import React, { createContext } from "react";
import FormControl from "@material-ui/core/FormControl";
import TextField from "@material-ui/core/TextField";
import Autocomplete from "@material-ui/lab/Autocomplete";
import PropTypes from "prop-types";

export const DevelopmentContext = createContext();
const { Provider } = DevelopmentContext;
const SearchDevelopment = ({ children, developments, onChange, defaultValue }) => {
  return (
    <Provider value={{ developments }}>
      <FormControl fullWidth>
        <Autocomplete
          id="combo-box-demo"
          options={developments}
          getOptionLabel={option => option.NOMBRE_DESARROLLO}
          defaultValue={defaultValue || null}
          onChange={(event, value) => {
            onChange(value);
          }}
          renderInput={params => (
            <TextField {...params} label="Desarrollo" variant="outlined" size="small" />
          )}
        />
      </FormControl>
      {children}
    </Provider>
  );
};
SearchDevelopment.propTypes = {
  children: PropTypes.element,
  idDevelopment: PropTypes.number,
  developments: PropTypes.array,
  onChange: PropTypes.func
};
export default SearchDevelopment;
